import { InjectionToken, Provider } from '@angular/core';

// declared here rather than imported so the core carries no dependency on the public environment library
export type GoogleMapsRegionCode = 'AU' | 'NZ' | 'US' | 'CA';

export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>('GOOGLE_MAPS_API_KEY');
export const GOOGLE_MAPS_REGION_CODE = new InjectionToken<GoogleMapsRegionCode>('GOOGLE_MAPS_REGION_CODE');

export function provideGoogleMaps(apiKey: string, regionCode: GoogleMapsRegionCode): Provider[] {
  return [
    { provide: GOOGLE_MAPS_API_KEY, useValue: apiKey },
    { provide: GOOGLE_MAPS_REGION_CODE, useValue: regionCode },
  ];
}
